export default [
  {
    path: "/customerRewards",
    component: () => import(/* webpackChunkName: "customerRewards" */ "./layout"),

    children: [
      {
        path: "/",
        name: "customerRewards.index",
        component: () => import(/* webpackChunkName: "customerRewards.index" */ "./index"),
      },
      {
        props: true,
        path: ":id",
        name: "customerRewards.show",
        component: () => import(/* webpackChunkName: "customerRewards,show" */ "./show"),
      },
    ],
  },
];
